<!-- CONTAINER -->
<div class="bg-white py-36px px-24px rounded-tl-[24px] rounded-tr-[24px]">
	<!-- HEADER SECTION -->

	<!-- filter -->
	<app-search-filter
		(keyWord)="searchText = $event; getCategories(true)"
		[showFilter]="false"
	></app-search-filter>

	<!-- table -->

	<div class="custom-table overflow-x-auto mt-[24px]">
		<table
			mat-table
			[dataSource]="dataSource"
			class="mat-elevation-z8 bg-transparent w-full relative"
		>
			<ng-container matColumnDef="NameEN">
				<th mat-header-cell *matHeaderCellDef>
					<span class="text-medium-gray px-3">{{
						'STORE.CATEGORY_LIST.ENGLISH_NAME' | translate
					}}</span>
				</th>
				<td
					*matCellDef="let data; let indx = index"
					class="p-0 {{ indx + 1 == categories.length ? 'border-b-0' : '' }} {{
						data.level == 0
							? 'border-b-[1px] border-secondry-color-Gray bg-grey-background '
							: 'custom-cell  '
					}}  {{
						data.level == 1
							? 'd-custom-cell t-btn-content'
							: data.level == 2 && indx + 1 != categories?.length
							? ' t-custom-cell '
							: ''
					}} h-[52px] {{
						data.parentId == null ? ' ltr:ml-[25px] rtl:mr-[25px]' : ''
					}} "
				>
					<div class="cell-content">
						<button
							mat-icon-button
							(click)="treeControl.toggle(data)"
							[attr.aria-label]="'Toggle ' + data.name"
							class=" h-[52px]  rounded-none  {{
								data.level == 0 && indx != 0
									? ' d-btn-content '
									: data.level == 3
									? ''
									: ''
							}}   {{
								!data.hasSubCategories && data.parentId != null
									? 'bg-white text-white rounded-none p-0 ltr:left-b'
									: ' text-main-color-black'
							}} w-[43px]"
						>
							<mat-icon
								class="mat-icon-rtl-mirror text-[18px]  {{
									data.level == 1 && data.hasSubCategories
										? 'ltr:ml-[40px] rtl:mr-[40px] mt-1'
										: ''
								}}  {{
									data.subCategories == null ||
									data.subCategories == [] ||
									!data.hasSubCategories
										? 'hidden'
										: ' '
								}}"
							>
								{{
									treeControl.isExpanded(data) ? 'expand_more' : 'chevron_right'
								}}
							</mat-icon>
						</button>
						<img
							*ngIf="data.parentId == null"
							[src]="attachmentUrl + data.imageUrl"
							alt=""
							class="w-[46px] h-[46px] ltr:mr-2 rtl:ml-2 max-mobile:w-[40px] max-mobile:h-[40px] rounded-full"
						/>

						<div
							class="cell-text  h-[55px] bg-grey-background w-full pt-[15px]  {{
								data.parentId == null
									? 'text-main-color-black'
									: 'text-medium-gray  ltr:border-l-[1px] ltr:border-l-secondry-color-Gray rtl:border-r-[1px] rtl:border-r-secondry-color-Gray'
							}} {{ !data.canAdd ? 'ltr:ml-[35px] rtl:mr-[35px]' : '' }}  {{
								data.level == 1
									? 'ltr:pl-[52px] rtl:pr-[52px]'
									: data.level == 2
									? 'ltr:pl-[18px] rtl:pr-[18px]'
									: ''
							}} "
						>
							{{ data?.name?.en | slice : 0 : 30 }}
							{{ data.name.en.length > 30 ? '...' : '' }}
						</div>
					</div>
				</td>
			</ng-container>

			<ng-container matColumnDef="NameAr">
				<th mat-header-cell *matHeaderCellDef class="text-medium-gray">
					{{ 'STORE.CATEGORY_LIST.ARABIC_NAME' | translate }}
				</th>
				<td
					mat-cell
					*matCellDef="let data"
					class="border-b-[1px] border-secondry-color-Gray bg-grey-background {{
						data.parentId == null
							? 'text-main-color-black'
							: 'text-medium-gray  '
					}}  "
				>
					<p class="px-1">
						{{ data?.name?.ar | slice : 0 : 30 }}
						{{ data.name.en.length > 30 ? '...' : '' }}
					</p>
				</td>
			</ng-container>
			<ng-container matColumnDef="count">
				<th mat-header-cell *matHeaderCellDef class="text-medium-gray">
					{{ 'STORE.CATEGORY_LIST.SERVICES' | translate }}
				</th>
				<td
					mat-cell
					*matCellDef="let data"
					class="border-b-[1px] border-secondry-color-Gray bg-grey-background  {{
						data.parentId == null
							? 'text-main-color-black'
							: 'text-medium-gray  '
					}} "
				>
					<p class="mx-1">
						{{ data.productCount }}
					</p>
				</td>
			</ng-container>

			<ng-container matColumnDef="activation">
				<th mat-header-cell *matHeaderCellDef class="text-medium-gray">
					{{ 'STORE.CATEGORY_LIST.ACTIVATION' | translate }}
				</th>
				<td
					mat-cell
					*matCellDef="let data; let indx = index"
					class="border-b-[1px] border-secondry-color-Gray bg-grey-background"
				>
					<mat-slide-toggle
						(click)="updateCategoryStatus(data)"
						[checked]="data?.isActive"
					></mat-slide-toggle>

					<span
						[ngClass]="data?.isActive ? 'text-[#00BA88]' : 'text-[#B3261E]'"
						class="inline-block mx-[16px] max-mobile:text-font-mobile-small align-top"
					>
						{{
							data?.isActive
								? ('ACTIONS.ACTIVE' | translate)
								: ('ACTIONS.INACTIVE' | translate)
						}}
					</span>
				</td>
			</ng-container>

			<ng-container matColumnDef="a">
				<th mat-header-cell *matHeaderCellDef class="text-medium-gray"></th>
				<td
					mat-cell
					*matCellDef="let data"
					class="border-b-[1px] border-secondry-color-Gray bg-grey-background relative w-[100px]"
				>
					<div
						class="max-mobile:w-[20px] flex gap-2 ltr:pr-[10px] rtl:pl-[10px] absolute top-[5px] ltr:right-[15px] rtl:left-[20px]"
					>
						<p
							class="mt-4 text-medium-gray cursor-pointer"
							*ngIf="data.canAdd"
							(click)="addEditSubCategory(data, 'add')"
						>
							+
						</p>
						<img
							(click)="addEditSubCategory(data, 'edit')"
							[src]="'assets/images/edit.svg'"
							alt=""
							class="inline-block cursor-pointer w-[16px] {{
								data.level == 3 ? 'mt-[13px]' : ''
							}}"
						/>
						<img
							*ngIf="data.canDelete"
							(click)="deleteCategory(data)"
							class="inline-block cursor-pointer w-[16px]"
							[src]="'assets/images/delete.svg'"
							alt=""
						/>
					</div>
				</td>
			</ng-container>

			<tr mat-header-row *matHeaderRowDef="displayedColumns" class=""></tr>
			<tr
				mat-row
				*matRowDef="let row; columns: displayedColumns"
				class="h-[52px]"
			></tr>
		</table>
	</div>
</div>
<app-no-data-found *ngIf="!categories?.length"></app-no-data-found>

<!-- fixed button -->
<app-fixed-button
	(click)="addCategory('add')"
	[buttonWidth]="200"
	[buttonTitle]="'STORE.CATEGORY_LIST.ADD_CATEGORY'"
	[imgPath]="'add-white.svg'"
></app-fixed-button>
